<template>
  <NotificationTemplate
    :notification="notification"
    class="notification__item-converted-to-epic"
  >
    <template #pic>
      <div class="label-pic is-pink-epic">
        <icon
          data="@icon/epic.svg"
          class="label-pic__icon"
          :fill="true"
          width="var(--icon-24)"
          height="var(--icon-24)"
        />
      </div>
    </template>
    <template #title>
      <BaseSubHeading
        size="large"
        color="monochrome-06"
        darkColor="monochrome-03"
        weight="500"
      >
        Item converted to Epic
      </BaseSubHeading>
    </template>
    <template #content>
      <BaseSubHeading
        size="large"
        color="monochrome-06"
        weight="500"
        className="notification__item-converted-to-epic__epic-info"
      >
        <span class="notification__item-converted-to-epic__item-title">
          Item {{ notification.itemSequenceNumber }}
        </span>
        <icon
          data="@icon/arrow-to.svg"
          :fill="true"
          width="24px"
          height="24px"
          color="#616161"
        />
        <a
          class="link is-large"
          target="_blank"
          :href="notification.epicUrl"
        >
          Epic {{ notification.epicSequenceNumber }}
        </a>
      </BaseSubHeading>
    </template>
  </NotificationTemplate>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component"
import { Prop } from "vue-property-decorator"

import NotificationTemplate from "@/components/Notification/NotificationTemplate.vue"

import { NotificationItemConvertedToEpic } from "@/models/Notification/NotificationItemConvertedToEpic"

@Options({
  name: "ITEM_CONVERTED_TO_EPIC",
  components: {
    NotificationTemplate
  }
})
export default class ITEM_CONVERTED_TO_EPIC extends Vue {
  @Prop() readonly notification: NotificationItemConvertedToEpic
}
</script>

<style lang="scss" scoped>
.notification__item-converted-to-epic__item-title {
  opacity: 0.5;
}
</style>
